import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { Control, useController } from 'react-hook-form';

export interface ModuleFieldProps {
  control: Control<any>;
  modules?: any[];
  name: string;
}

const ModuleField = ({ control, modules, name }: ModuleFieldProps) => {
  const { field } = useController({ control, name });

  useEffect(() => {
    if (modules && field.value) {
      field.onChange(null);
    }
  }, [modules]);

  const getOptionLabel = optionId => modules?.find(e => e.id === optionId)?.title ?? '';

  return (
    <Autocomplete
      data-cy="select-module"
      clearOnBlur
      disableClearable
      disabled={!modules}
      getOptionLabel={getOptionLabel}
      handleHomeEndKeys
      renderOption={(props, optionId) => (
        <li {...props} key={optionId} data-cy={`select-option-${getOptionLabel(optionId)}`}>
          {getOptionLabel(optionId)}
        </li>
      )}
      options={(modules ?? []).map(e => e.id)}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: params.InputProps.endAdornment,
          }}
          label="Modules"
        />
      )}
      {...field}
      onChange={(event, option) => field.onChange(option)}
    />
  );
};

export default ModuleField;
